module.exports = __webpack_public_path__ + "img/creator-(3).04558d5f.png";